import { render, staticRenderFns } from "./CategoriesTable.vue?vue&type=template&id=6b841b8c&scoped=true&"
import script from "./CategoriesTable.vue?vue&type=script&lang=js&"
export * from "./CategoriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b841b8c",
  null
  
)

export default component.exports